import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';

// @ts-expect-error - Automatic, Please fix when editing this file
const mapFeaturesAndBenefits = ({ cmsSectionContent }) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  return {
    type: CONTENT_SECTIONS.FEATURES_AND_BENEFITS,
    ...cmsSectionContent,
  };
};

export default mapFeaturesAndBenefits;
